import { useEffect, useState } from "react";

/**
 * OfflineBanner — shows a small pill at the top of the viewport when the
 * browser reports `navigator.onLine === false`. Pure client-side, no Convex
 * dependency: works whether or not the backend is provisioned.
 */
export function OfflineBanner(): React.JSX.Element | null {
  const [online, setOnline] = useState<boolean>(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    const onOnline = (): void => setOnline(true);
    const onOffline = (): void => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <output
      aria-live="polite"
      className="fixed top-3 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-full border border-amber-500/40 bg-amber-500/10 px-3 py-1.5 text-xs font-medium text-amber-300 shadow-[0_4px_12px_rgba(0,0,0,0.4)] backdrop-blur-md"
    >
      <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-amber-400" aria-hidden />
      Offline — workouts run locally
    </output>
  );
}
